export function isMobileLike(): boolean {
  if (typeof window === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const uaHint = /Android|iPhone|iPod|iPad|Mobile|Phone|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  const touch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const narrow = window.matchMedia('(max-width: 820px)').matches;
  // Treat as mobile if UA says so, OR if it has touch AND is narrow.
  return uaHint || (touch && narrow);
}

export function hasCamera(): boolean {
  return typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getUserMedia;
}
